<template>
  <v-tooltip bottom color="transparent">
    <template v-slot:activator="{ on }">
      <td
        v-on="on"
      >
        <span class="shimmer">
          {{ formatCurrency(_.last(sortedPriceRanges).Price) }}
          - {{ formatCurrency(_.first(sortedPriceRanges).Price) }}

          <!-- Removed since no min qty anymore? -->
          <!--          / {{ _.first(sortedPriceRanges).Qty }}-->
        </span>
      </td>
    </template>
    <span>
      <v-card width="max-content">
        <v-card-title class="subtitle-1 d-flex justify-center">
          Unit Price by Quantity
        </v-card-title>

        <v-divider />

        <v-list
          color="transparent"
          dense
        >
          <v-list-item
            v-for="(p, i) in priceRangeData"
            :key="i"
          >
            <v-list-item-content>
              {{ _.split(p, ':')[0] + ':' }}
            </v-list-item-content>

            <v-list-item-content class="align-end pr-6">
              {{ _.split(p, ':')[1] }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </span>
  </v-tooltip>
</template>

<script>
import CurrencyFormatterMixin from '../../mixins/currencyFormatter';

export default {
  name: 'TableUnitPricing',

  mixins: [
    CurrencyFormatterMixin,
  ],

  props: {
    item: Object,
  },

  computed: {
    priceRangeData() {
      const priceRanges = [];

      for (let i = 0; i < this.sortedPriceRanges.length; i++) {
        const price = this.formatCurrency(this.sortedPriceRanges[i].Price);
        const qty = this.sortedPriceRanges[i].Qty;
        const text = `${qty}: ${price}/unit`;
        priceRanges.push(text);
      }

      return priceRanges;
    },

    sortedPriceRanges() {
      return _.sortBy(this.priceRange, (p) => p.Qty);
    },

    priceRange() {
      return JSON.parse(this.item.PriceMOQ);
    },
  },
};
</script>

<style>
  .hovered .shimmer {
    display: inline-block;
    color: white;

    background: rgba(0, 0, 0, 0.87) -webkit-gradient(linear, 100% 0, 0 0,
    from(rgba(0, 0, 0, 0.87)), color-stop(0.5, #ffffff),
    to(rgba(0, 0, 0, 0.87)));

    background-position: -4rem top; /*50px*/
    background-repeat: no-repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-animation-name: shimmer;
    -webkit-animation-duration: 1s;
    -webkit-animation-iteration-count: infinite;
    -webkit-background-size: 4rem 100%; /*50px*/
    -webkit-animation-timing-function: linear;
  }

  @-webkit-keyframes shimmer {
    from {
      background-position: -4rem top; /*50px*/
    }
    to {
      background-position: 11rem top; /*200px*/
    }
  }
</style>
